import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Index = () => import("./views/pcPage/Index.vue");
const ICP = () => import("./views/ICP.vue");
const Login = () => import("./views/pcPage/Login.vue");
const Register = () => import("./views/pcPage/Register.vue");
const MIndex = () => import("./views/mPage/MIndex.vue");
const MLogin = () => import("./views/mPage/MLogin.vue");
const MRegister = () => import("./views/mPage/MRegister.vue");

const routes = [
  {
    path: "/",
    name: "index",
    component: Index
  },
  {
    path: "/ett/:type",
    name: "index",
    component: Index
  },
  {
    path: "/icp",
    name: "icp",
    component: ICP
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/m",
    name: "mindex",
    component: MIndex
  },
  {
    path: "/mett/:type",
    name: "mindex",
    component: MIndex
  },
  {
    path: "/mlogin",
    name: "mlogin",
    component: MLogin
  },
  {
    path: "/mregister",
    name: "mregister",
    component: MRegister
  }
];

const router = new Router({
  routes
});

router.afterEach(() => {
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function() {
      //每次执行前，先移除上次插入的代码
      document.getElementById("baidu_tj") &&
        document.getElementById("baidu_tj").remove();
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?8b2d016c7a7351dc6cce42ca30b2632b";
      hm.id = "baidu_tj";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 0);
});

export default router;
